import { render } from "./FormModalClientFile.vue?vue&type=template&id=1181dbd5&scoped=true"
import script from "./FormModalClientFile.vue?vue&type=script&lang=js"
export * from "./FormModalClientFile.vue?vue&type=script&lang=js"

import "./FormModalClientFile.vue?vue&type=style&index=0&id=1181dbd5&scoped=true&lang=css"
import "./FormModalClientFile.vue?vue&type=style&index=1&id=1181dbd5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1181dbd5"]])

export default __exports__